<template>
    <el-dialog class="add_supplier" :visible.sync="dialogVisible" :append-to-body="true" :title="dialogTitle"
        width="700px" @close="handleClose">
        <div class="supplier">
            <div class="supplier-form" v-if="type === 'edit'">
                供应商编码：{{ form.supplierCode }}
            </div>
            <el-form :model="form" :rules="rules" ref="supplierForm" label-width="100px" label-position="right">
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="供应商名称" prop="name">
                            <el-input :maxlength="32" v-model="form.name" clearable placeholder="请输入"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="供应商分类" prop="category">
                            <el-select v-model="form.category" placeholder="请选择" clearable filterable
                                default-first-option>
                                <el-option v-for="(item, index) in dictionaries.supplier_category" :key="item.dictId"
                                    :value="item.dictName" :label="item.dictName"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="联系人">
                            <el-input :maxlength="30" v-model="form.contactPerson" clearable
                                placeholder="请输入"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="联系号码">
                            <el-input :maxlength="20" v-model="form.contactNumber" clearable placeholder="请输入"
                                oninput="if (/\D/g.test(this.value)) this.value = this.value.replace(/\D/g,'')">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="邮箱地址">
                            <el-input :maxlength="100" v-model="form.email" clearable placeholder="请输入"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="结算期限">
                            <el-select v-model="form.settlementPeriod" placeholder="请选择" clearable default-first-option>
                                <el-option v-for="(item, index) in dictionaries.settlement_period" :key="item.dictId"
                                    :label="item.dictName" :value="item.dictId"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="信用额度">
                            <el-input v-model="form.creditLimit" maxlength="20"
                                oninput="if (/\D/g.test(this.value)) this.value = this.value.replace(/\D/g,'')"
                                clearable placeholder="请输入"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="发票抬头">
                            <el-input v-model="form.invoiceHeader" maxlength="100" clearable
                                placeholder="请输入"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="开户银行">
                            <el-input v-model="form.bankName" maxlength="100" clearable placeholder="请输入"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="收款账号">
                            <el-input :maxlength="30" clearable v-model="form.bankAccountNumber"
                                oninput="if (/\D/g.test(this.value)) this.value = this.value.replace(/\D/g,'')"
                                placeholder="请输入"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <!-- 供应商地址单独一行 -->
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="供应商地址">
                            <el-input :maxlength="100" clearable v-model="form.address" placeholder="请输入"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <!-- 备注单独一行 -->
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="备注">
                            <el-input type="textarea" clearable :rows="2" :maxlength="64" v-model="form.remarks"
                                placeholder="请输入"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button size="mini" type="primary" @click="submitForm">确定</el-button>
            <el-button size="mini" @click="dialogVisible = false">取消</el-button>
        </div>
    </el-dialog>
</template>

<script>
export default {
    name: 'SupplierDialog',
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        type: {
            type: String,
            default: 'add' // 'add' 或 'edit'
        },
        formData: {
            type: Object,
            default: () => ({})
        },
        supplierNames: {
            type: Array,
            default: () => []
        },
        remoteMethod: {
            type: Function,
            default: () => { }
        }
    },
    data() {
        const validateSupplierName = (rule, value, callback) => {
            if (!value) {
                callback(new Error('请输入供应商名称'));
            } else {
                callback();
            }
        };
        const validateSupplierCategory = (rule, value, callback) => {
            if (!value) {
                callback(new Error('请选择供应商分类'));
            } else {
                callback();
            }
        };

        return {
            rules: {
                name: [{ required: true, validator: validateSupplierName, trigger: 'blur' }],
                category: [{ required: true, validator: validateSupplierCategory, trigger: 'change' }]
            },
            form: {
                id: null,
                name: '',
                category: '',
                contactPerson: '',
                contactNumber: '',
                email: '',
                settlementPeriod: '',
                creditLimit: null,
                invoiceHeader: '',
                bankName: '',
                bankAccountNumber: '',
                address: '',
                remarks: '',
                supplierCode: ''
            },
            dictionaries: { // 字典数据
                settlement_period: [], // 结算期限
                supplier_category: [] // 供应商分类
            },
        };
    },
    created() {
        // 批量获取字典数据
        this.getMultipleDictionaries(['settlement_period', 'supplier_category'])
    },
    computed: {
        dialogVisible: {
            get() {
                return this.visible;
            },
            set(value) {
                this.$emit('update:visible', value);
            }
        },
        dialogTitle() {
            return this.type === 'add' ? '新增供应商' : '编辑供应商';
        }
    },
    watch: {
        formData: {
            immediate: true,
            deep: true,
            handler(newVal) {
                if (newVal) {
                    this.form = { ...this.form, ...newVal };
                }
            }
        }
    },
    methods: {
        // 远程搜索供应商分类
        remoteSMethod(query) {
            this.remoteMethod(query);
        },

        // 提交表单
        submitForm() {
            this.$refs.supplierForm.validate(valid => {
                if (valid) {
                    this.$emit('submit', { ...this.form });
                } else {
                    this.$message.error('请填写必填项');
                    return false;
                }
            });
        },

        // 关闭弹窗
        handleClose() {
            this.$refs.supplierForm.clearValidate();
            this.$emit('closed');
        },

        // 重置表单
        resetForm() {
            this.form = {
                id: null,
                name: '',
                category: '',
                contactPerson: '',
                contactNumber: '',
                email: '',
                settlementPeriod: '',
                creditLimit: null,
                invoiceHeader: '',
                bankName: '',
                bankAccountNumber: '',
                address: '',
                remarks: '',
                supplierCode: ''
            };
            this.$refs.supplierForm.clearValidate();
        },
        // 批量获取字典数据
        getMultipleDictionaries(types) {
            types.forEach(type => {
                this.getDictionaries(type)
            })
        },
        // 获取字典数据
        getDictionaries(type) {
            if (type && this.dictionaries[type].length > 0) { return }
            const params = { groupId: type }
            this.$api.dictionaries(params).then((res) => {
                this.dictionaries[type] = res.data
            }).catch((err) => {
                console.log(err)
            })
        },
    }
};
</script>

<style scoped lang="scss">
.add_supplier {
    /deep/ {
        .el-dialog__title {
            font-weight: 400;
            font-size: 16px;
            color: #333333;
        }
    }
}

.supplier {
    margin-top: 20px;

    /deep/.el-form-item__label {
        width: 100px;
        height: 30px;
        line-height: 30px;
    }

    /deep/.el-input,
    /deep/.el-input__inner {
        height: 30px;
        line-height: 40px;
    }

    /deep/.el-form-item {
        margin-bottom: 15px;
    }

    /deep/ {
        .el-textarea {
            width: 100%;
        }
    }

    /deep/.el-select {
        width: 100%;

        .el-input__icon {
            height: 30px;
            line-height: 30px;
        }
    }
}

.supplier-form {
    font-weight: 400;
    font-size: 16px;
    color: #333333;
    margin-left: 17px;
    margin-bottom: 10px;
}
</style>